import { getAppState } from "../state";
import { getCurrentProfile } from "./multipleProfilesService";
import { getSdk } from "./sdkService";
import { isAnyAddonStatusActive } from "../utils/subscriptionUtils";
import * as Sentry from "@sentry/browser";
export async function getUserData(avoidCache = false) {
  const appState = getAppState();
  try {
    const sdk = await getSdk();
    const result = await sdk.userManager.get({ avoidCache });
    if (
      result &&
      (isUserAccountActive(result.settings.accountStatus) || isAnyAddonStatusActive(result.settings?.addons))
    ) {
      appState.isSvodUser = true;
    } else {
      appState.isSvodUser = false;
    }
    const currentProfile = await getCurrentProfile();
    if (avoidCache) {
      localStorage.setItem(
        "parentalLevel",
        (currentProfile && currentProfile.parentalControl) || result.settings.parentalControl
      );
      localStorage.setItem("globalUserId", result.globalUserId);
    }
    getAppState().signupType = result ? result.signupType : null;
    Sentry.setUser(result);
    return result;
  } catch (error) {
    appState.userAccountFailed = true;
    Sentry.captureException(error);
    throw error;
  }
}

/**
 * Checks in current user account status is active.
 * @param {String} status - User account status.
 */
export function isUserAccountActive(status) {
  return status && status.toLowerCase() === "active";
}

/**
 * Checks in current user account status is prospect.
 * @param {String} status - User account status.
 */
export function isUserAccountProspect(status) {
  return status.toLowerCase() === "prospect";
}

export function storeProfileInfo(userData) {
  const appState = getAppState();
  const profileData = {
    emailAddress: userData.emailAddress || "",
    firstName: userData.firstName || "",
    lastName: userData.lastName || "",
    mobilePhone: userData.mobilePhone || ""
  };
  appState.userProfileInfo = profileData;
  return profileData;
}
